<template>
  <div class="direct-api-chat">
    <div class="chat-header">
      <div style="display: flex;align-items: center;" >
        <el-image style="width: 30px;" src="https://data.chinaecono.com/images/logo_2.png" fit="fill" />
        <span style="margin-left: 10px;font-weight: 900;">经济数据分析助手</span>
      </div>
      <el-popover  placement="bottom" :width="200" trigger="hover" >
        <template #reference>
          <el-avatar   :size="30" :src="currentUser?.picUrl" style="cursor: pointer;" ></el-avatar>
        </template>
        <div class="user-float" >
          <div class="user-name">
            <span style="">{{currentUser?.userName}}</span>
          </div>
          <ul>
            <li class="css-1e76yen" @click="pushSearch(`/people`,`people`)">
              <i class="iconfont ec-icon-s-user"></i>
              <span>我的主页</span>
            </li>
            <li class="css-1e76yen" @click="pushSearch('/user-center','usercenter')">
              <i class="iconfont ec-icon-setting-fill"></i>
              <span>个人中心</span>
            </li>
            <li class="css-1e76yen" @click="loginOut">
              <i class="iconfont ec-icon-exit"></i>
              <span>退出</span>
            </li>
          </ul>
        </div>
      </el-popover>
    </div>
    <div class="chat-container-pc">
      <div class="chat-aside">
        <div class="fold-aside-new" v-show="!drawer">
          <!-- <div class="fold-aside-expand" @click="drawer=true"> -->
          <div class="fold-aside-expand">
            <i class="iconfont ec-icon-expand-right"></i>
          </div>
          <div class="fold-aside-divider"></div>
          <div class="fold-aside-new-dialog" @click="OpenNewdialogFun">+新对话</div>
        </div>
        <div v-show="drawer" class="dc04ec1d">
          <div class="sidebar-header">
            <!-- <el-image style="height: 35px" src="https://data.chinaecono.com/images/logo.png?t=1683356233" fit="fill" /> -->
            <i class="iconfont ec-icon-expand-left" @click="drawer=false"></i>
          </div>
          <el-button round style="margin: 6px 8px;width: calc(100% - 16px);">+新对话</el-button>
          <div>
            <div class="sidebar-nav-title">
              <i class="iconfont ec-icon-browse"></i>
              <span>历史对话</span>
            </div>
            <ul>
              <li v-for="item in dialogList" :key="item.id">
                <div class="chat-info-item" :class="{'router-link-active':item.id==1}">
                  <span class="chat-name">{{ item.title }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="isShowHello==1" style="display:flex;flex-direction:column;justify-content:center;">
        <h1>
          <span>👋</span>
          <span>我是经济数据分析助手，您想了解哪些经济信息呢？</span>
        </h1>
        <div class="input-wrapper">
          <textarea
            v-model="txtParams"
            @keydown.enter.exact.prevent="AddNewdialogFun"
            @keydown.enter.shift.exact="handleShiftEnter_start"
            placeholder="输入消息... (例如：北京的常住人口情况？)"
            rows="3"></textarea>
          <div style="display: flex;align-items: center; justify-content:end;gap: 10px;">
            <el-dropdown @command="handleModelFun">
              <span >
                {{modelList.find(t=>t.id==selModel).title}}
                <i class="iconfont ec-icon-arrow-bottom"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="item in modelList" :key="item.id" :command="item.id">{{ item.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <button  @click="AddNewdialogFun" :disabled="txtParams.trim().length<=0"  class="send-button">
              <span class="iconfont ec-icon-top"></span>
            </button>
          </div>
        </div>
      </div>
      <div v-else class="chat-container">
        <!-- 消息区域 -->
        <div class="messages" ref="messagesRef">
          <div  v-for="(message, index) in showMessages"  :key="index" :class="['message', message.role]">
            <!-- 普通消息 -->
            <div class="message-content">
              <!-- <div class="message-avatar">
                {{ message.role === 'user' ? '👤' : '🤖' }}
              </div> -->
              <div class="message-text" :style="{'width':message.role=='user'?'auto':'100%'}">
                <div v-if="message.reasoning_content" class="thinking-content" @click="message.isShowThinking=!message.isShowThinking">
                  <div class="thinking-label" >
                    <span>思考过程:</span>
                    <i class="iconfont ec-icon-arrow-bottom" v-show="!message.isShowThinking"></i>
                  </div>
                  <div class="thinking-text" v-show="message.isShowThinking">{{ message.reasoning_content }}</div>
                </div>
                <div v-html="message.content"></div>
              </div>
            </div>
          </div>
          
          <!-- 加载指示器 -->
          <div v-if="isLoading" class="loading">
            <div class="loading-content">
              <div class="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div v-if="currentToolCall" class="tool-calling">
                正在调用 {{ currentToolCall.name }} API...
              </div>
            </div>
          </div>
        </div>
        
        <!-- 输入区域 -->
          <div class="input-wrapper">
            <textarea
              v-model="inputText"
              @keydown.enter.exact.prevent="sendMessage"
              @keydown.enter.shift.exact="handleShiftEnter"
              placeholder="输入消息... (例如：北京的常住人口情况？)"
              :disabled="isLoading"
              rows="3"></textarea>
            <div style="display: flex;align-items: center; justify-content:end;gap: 10px;">
              <el-dropdown @command="handleModelFun">
                <span >
                  {{modelList.find(t=>t.id==selModel).title}}
                  <i class="iconfont ec-icon-arrow-bottom">
                  </i>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item v-for="item in modelList" :key="item.id" :command="item.id">{{ item.title }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <button  @click="sendMessage" :disabled="isLoading || !inputText.trim()" class="send-button">
                <span class="iconfont ec-icon-top"></span>
              </button>
            </div>
          </div>
        
      </div>
      <!-- 调用工具 -->
      <div style="width: 321px;height: 100%;" >
        <div v-if="isShowHello!=1" class="right-bar-wrapper">
        <div>
          <div class="wrapper-head">调用本地数据库</div>
            <div v-for="(item,index) in  Array.from(new Set(toolResults?.filter(t=>t.desc!='联网搜索').map(t=>t.desc)))" :key="index" style="padding: 6px;">
              <span>{{ item }}</span>
            </div>
        </div>
        <div>
          <div class="wrapper-head">全网搜索</div>
          <div v-for="(item,index) in toolResults.filter(t=>t.desc=='联网搜索').reduce((acc, { data }) => acc.concat(data), [])" :key="index" style="padding: 6px;display: flex;gap: 6px;">
            <i class="iconfont ec-icon-website" style="color:#9195a3;margin-top: 2px;"></i>
            <el-link type="primary" :underline="false" target="_blank" :href="item.link">{{item.title}}</el-link>
            <!-- <br/>
            <span style="color: #606266;">{{ item.snippet }}</span> -->
          </div>
        </div>
      </div>
      </div>
    </div>
    <el-dialog
      v-model="$store.state.loginVisable"
      title=""
      :width='420'
      custom-class="login-dialog"
      destroy-on-close 
      :close-on-click-modal='false'
      @close='loginCloseFun'>
      <login></login>
    </el-dialog>
  </div>
</template>

<script >
import { ref, onMounted,onUnmounted, nextTick,computed,inject } from 'vue';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import OpenAI from 'openai';
import {getItemList,getMultiRegionItemDataList,getRegionIndustryDataList,getItemListOfEcoIndustry,getItemObjList,getProductList,getPosList,getHouseDataList,getWorkDataList,getProductDataList} from '@/http/ecoApi'
import {getCodeRegionList,getUserRightFun,getIsLogin} from '@/http/basicsApi'
import Login from '@/components/Login'
import { useRouter,useRoute } from 'vue-router';
import * as echarts from 'echarts'
export default {
  components:{
    Login
  },
  setup() {
    const router=useRouter();//路由
    const route=useRoute();//当前路由
    let aiSearch=route.query['_chatQuery']||''//搜索内容
    let isShowHello=ref(route.query['isShowHello']||1)//是否显示开始对话的提示语
    // let ori_id=route.query['id']||''//消息ID
    if(aiSearch){
      isShowHello.value=0
    }
    //用户信息
    let currentUser=computed(()=>JSON.parse( localStorage.getItem('currentUser')));//当前用户信息
    let reload=inject('reload');
    // 响应式数据
    let modelList=ref([{id:1,title:'DS-V3.2思考',label:'Pro/deepseek-ai/DeepSeek-V3.2'},{id:2,title:'K2.5思考',label:'Pro/moonshotai/Kimi-K2.5'}])//模型列表
    let selModel=ref(1)//选中模型ID
    let drawer=ref(false)//历史对话的对话框
    let dialogList=ref([{id:1,title:'经济分析'},{id:2,title:'经济数据经济数据房价分析'}])//历史对话列表
    let txtParams=ref('')
    const messages = ref([]);//多轮对话的消息
    const showMessages = ref([]);//页面显示的对话消息，用户一次输入表示一次对话,即模型多轮对话为模型一次输出
    const inputText = ref('');
    const isLoading = ref(false);
    const enableTools = ref(true);
    const messagesRef = ref(null);
    const currentToolCall = ref(null);
    const toolResults = ref([]); // 存储工具调用结果
    const toolErrors = ref(new Map()); // 存储工具调用错误
    let isShowThinking=ref(false);//是否显示思考过程
    const md = new MarkdownIt({
      html: true,
      linkify: true
    });
    // OpenAI 客户端
    const client = new OpenAI({
      //阿里
      // apiKey: 'sk-648ca070e674401fa337148fc5db9fdb',
      // baseURL: 'https://dashscope.aliyuncs.com/compatible-mode/v1',//'https://api.deepseek.com',
      //deepseek
      // apiKey: 'sk-c014bccb090649c5bf81ff197a7190ae',
      // baseURL: 'https://api.deepseek.com',
      //硅基流动
      apiKey: 'sk-guqncwzelqeoynkokzxkninnorxzyfrnlvtoaemusudhjuhl',
      baseURL: 'https://api.siliconflow.cn/v1',
      
      dangerouslyAllowBrowser: true,
    });
    // 工具定义
    const tools = [
      {
        type: 'function',
        function: {
          name: 'get_item_list',
      
          description: '获取经济指标信息',
          parameters: {
            type: 'object',
            properties: {
              itemName: {
                type: 'string',
                description: '指标名称，例如：地区生产总值、年末常住人口'
              }
            },
            required: ['itemName']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_region_list',
          description: '获取地区基本信息，参数name和parent必须填写一个',
          parameters: {
            type: 'object',
            properties: {
              name: {
                type: 'string',
                description: '地区名称：北京、上海、深圳'
              },
              parent: {
                type: 'string',
                description: '上级地区代码：110000，130100'
              },
            },
            required: []
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_regionItemData_List',
          description: '获取多个同级地区指标数据',
          parameters: {
            type: 'object',
            properties: {
              itemId: {
                type: 'string',
                description: '指标ID'
              },
              regionCode: {
                type: 'string',
                description: '地区代码，多个地区代码，用逗号分隔'
              },
              date:{
                type: 'string',
                description: '开始日期，格式：YYYY-MM-DD'
              },
              endDate:{
                type: 'string',
                description: '结束日期，格式：YYYY-MM-DD'
              }
            },
            required: ['itemId','regionCode','date']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_industry_item_list',
          description: '获取某个行业的指标信息',
          parameters: {
            type: 'object',
            properties: {
              itemName: {
                type: 'string',
                description: '指标名称'
              },
              industryId: {
                type: 'string',
                description: '国民经济行业分类代码，例如：A,B,A01'
              }
            },
            required: ['itemName','industryId']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_regionIndustryItemData_List',
          description: '获取多个同级地区行业指标数据',
          parameters: {
            type: 'object',
            properties: {
              itemId: {
                type: 'string',
                description: '指标ID'
              },
              regionCode: {
                type: 'string',
                description: '地区代码，多个地区代码，用逗号分隔'
              },
              industryId: {
                type: 'string',
                description: '行业代码,国民经济行业分类代码'
              },
              date:{
                type: 'string',
                description: '开始日期，格式：YYYY-MM-DD'
              },
              endDate:{
                type: 'string',
                description: '结束日期，格式：YYYY-MM-DD'
              }
            },
            required: ['itemId','regionCode','industryId','date']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_micro_item_List',
          description: '获取微观经济(房价、招聘、物价)的指标信息',
          parameters: {
            type: 'object',
            properties: {
              class: {
                type: 'integer',
                description: '指标分类，1：房价、2：招聘、3：物价'
              }
            },
            required: ['class']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_micro_product_List',
          description: '获取物价的产品信息',
          parameters: {
            type: 'object',
            properties: {
              name: {
                type: 'string',
                description: '产品名称,例如：白酒、猪肉'
              }
            },
            required: ['name']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_micro_pos_List',
          description: '获取招聘的职位列表',
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_houseData_List',
          description: '获取房价数据，更新周期为一月',
          parameters: {
            type: 'object',
            properties: {
              regionCode: {
                type: 'string',
                description: '地区代码，多个用逗号分隔'
              },
              itemId: {
                type: 'string',
                description: '指标ID，来自get_micro_item_List接口返回的itemId'
              },
              date:{
                type: 'string',
                description: '开始日期，格式：YYYY-MM-DD'
              },
              endDate:{
                type: 'string',
                description: '结束日期，格式：YYYY-MM-DD'
              }
            },
            required: ['regionCode']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_workData_List',
          description: '获取招聘数据，更新周期为一周',
          parameters: {
            type: 'object',
            properties: {
              regionCode: {
                type: 'string',
                description: '地区代码，多个用逗号分隔'
              },
              posId: {
                type: 'string',
                description: '职位ID，来自get_micro_pos_List接口返回的Id'
              },
              date:{
                type: 'string',
                description: '开始日期，格式：YYYY-MM-DD'
              },
              endDate:{
                type: 'string',
                description: '结束日期，格式：YYYY-MM-DD'
              }
            },
            required: ['regionCode']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'get_productData_List',
          description: '获取物价数据，更新周期为一旬',
          parameters: {
            type: 'object',
            properties: {
              regionCode: {
                type: 'string',
                description: '地区代码，多个用逗号分隔'
              },
              proId: {
                type: 'string',
                description: '产品ID,多个用逗号隔开，来自get_micro_product_List接口返回的Id'
              },
              date:{
                type: 'string',
                description: '开始日期，格式：YYYY-MM-DD'
              },
              endDate:{
                type: 'string',
                description: '结束日期，格式：YYYY-MM-DD'
              }
            },
            required: ['regionCode','proId']
          }
        }
      },
      {
        type: 'function',
        function: {
          name: 'web_search',
          description: '联网搜索关于经济方面的信息',
          parameters: {
            type: 'object',
            properties: {
              query: {
                type: 'string',
                description: '地区代码，多个用逗号分隔'
              }
            },
            required: ['query']
          }
        }
      },
    ];
    const sysContent=`## 角色设定
你是专业的经济数据分析师，专注于提供精准、及时的经济数据解读与可视化分析。
## 核心任务
当用户询问经济数据时，你必须：
1. 基于搜索结果进行专业分析
2. 按固定格式输出完整报告
## 输出格式规范
### 数据概览
- 以表格或结构化文字呈现关键数据指标
- 注明数据发布日期、统计口径、数据来源
### 数据可视化
严格使用以下JSON格式（ECharts配置）：
\`\`\`json
{
  "option": {
    "title": { "text": "图表标题", "left": "center" },
    "tooltip": { "trigger": "axis", "formatter": "{b}年：{c}亿元" },
    "legend": { "data": ["系列1", "系列2"], "bottom": 10 },
    "xAxis": { 
      "type": "category", 
      "data": ["标签1", "标签2", "标签3"]
    },
    "yAxis": { 
      "type": "value", 
      "name": "单位" 
    },
    "series": [
      {
        "name": "系列1",
        "data": [120, 200, 150],
        "type": "bar",
        "itemStyle": { "color": "#5470c6" }
      }
    ]
  }
}
\`\`\`
### 结论分析
- 基于数据进行客观解读
- 指出数据趋势、异常点或关键变化
- 必要时提供简要的政策或市场背景
## 严格约束
1. 工具调用强制
- 必须调用web_search获取最新、权威的数据
- 可多次调用以确保数据完整性
2. 回答范围限制
- 对于非经济类问题（如娱乐、文学、编程、日常生活等），统一回复：
  > "我专注于经济数据与分析，无法回答此问题。请提供GDP、CPI、PMI、利率、汇率、财政收支、产业数据等经济相关咨询。"
3. JSON纯净性
- 仅使用字符串、数值、布尔类型
- **禁止函数、箭头函数、new操作符**（如\`function(params)\`、\`new echarts.graphic.LinearGradient\`）
- 颜色使用十六进制字符串（如 \`"#5470c6"\`）
4. 时效性与准确性
- 优先使用最新发布数据
- 明确标注数据来源（如"国家统计局2024年1-12月数据"）
5. 专业度要求
- 分析需客观、严谨，避免主观臆测
- 区分"同比"与"环比"，注明计算口径
- 涉及预测时明确标注为"预测"并说明依据

今天是 ${new Date().toLocaleDateString()}，你想了解哪方面的经济信息呢？`
    // 初始化
    onMounted(() => {
      console.log('初始化',new Date().toLocaleDateString(),messages.value)
      //const navigationType = performance.getEntriesByType('navigation')[0]?.type
      
      messages.value = [
        {
          role: 'system',
          //content: `你好！我是你的专属经济数据助手，我可以帮你查询各地区的宏观经济、行业数据、企业信息以及房价、招聘、物价等实时数据。当前日期是${new Date().toLocaleDateString()}请问想了解哪方面的信息？`,
          content:sysContent
        }
      ];
      if(aiSearch){
        inputText.value=aiSearch
        sendMessage()
      }
    });
    onUnmounted(() => {
      cancelChat()
    })
    const sendMessage2=async()=>{
      let fullContent=''
      let source=[]
      let link=[]
      showMessages.value.push({
        role: 'user',
        content: inputText.value,
      });
      showMessages.value.push({
        role: 'assistant',
        content: '',
        reasoning_content:''
      });
      try {
        // 1. 发送 fetch 请求，配置流式响应
        const apiUrl = 'http://localhost:5125/api/Chat/chat/stream/all';
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 如有认证需求，添加 token
            // 'Authorization': 'Bearer your-token-here'
          },
          body: JSON.stringify({
            question: inputText.value // 传递复杂参数（对应后端的 ChatRequest）
          }),
          cache: 'no-cache'
        });
        console.log('响应',response)
        // 2. 校验响应是否成功
        if (!response.ok) {
          throw new Error(`请求失败：${response.status} ${response.statusText}`);
        }

        // 3. 获取 ReadableStream 并解析
        const reader = response.body?.getReader();
        if (!reader) {
          throw new Error('无法获取流式响应阅读器');
        }
        const decoder = new TextDecoder('utf-8'); // 用于解码 Uint8Array 为字符串
        // 4. 循环读取流式数据
        let aa=true
        while (aa) {
          // 读取下一块数据
          const { done, value } = await reader.read();
          if (done) {
            // 数据读取完毕
            console.log('流式传输正常结束');
            break;
          }
          // 5. 解码并处理数据（拆分每条消息，处理 \n\n 分隔符）
          const chunk = decoder.decode(value, { stream: true });
          console.log('chunk', chunk);
          const messages = chunk.replace(/\\"/g, '"').split('\\n\\n').filter(msg => msg.trim()); // 拆分多条消息并过滤空值
          console.log('消息组', chunk,messages)
          for (const msg of messages) {
            // 提取 data: 后面的内容（对应后端的格式）
            
            const dataPrefix = '"data:';
            let con= msg.trim().slice(1, -1);
            console.log('消息',con.startsWith(dataPrefix),con)
            //if (con && con.startsWith(dataPrefix)) {
            //  const dataContent = con.slice(dataPrefix.length).trim();
              console.log('数据内容',con)
              // 处理结束标识
              if (con === '[DONE]') {
                console.log('收到结束标识，停止接收');
                break;
              }
              // 解析 JSON 并更新页面
              try {
                const result = JSON.parse(con);
                if (result.Content) {
                  fullContent += result.Content;
                  const rawHtml = md.render(fullContent);
                  showMessages.value[showMessages.value.length-1].content=DOMPurify.sanitize(rawHtml) || ''// XSS 防护;
                  console.log('收到内容：', result.Content);
                }else if(result.ReasoningContent){
                  showMessages.value[showMessages.value.length-1].reasoning_content+=result.ReasoningContent || ''
                  console.log('收到内容：', result.ReasoningContent);
                }else if(result.Source){
                  source.push(result.Source)
                  showMessages.value[showMessages.value.length-1].source=source
                  console.log('收到内容：', result.reasoningContent);
                }else if(result.Url){
                  link.push(result.Url)
                  showMessages.value[showMessages.value.length-1].link=link
                  console.log('收到内容：', result.reasoningContent);
                }else if(result.Error){
                  showMessages.value[showMessages.value.length-1].content+=result.Error
                  console.log('收到内容：', result.reasoningContent);
                }
              } catch (e) {
                // 非 JSON 格式，直接追加（容错）
                console.log('收到非 JSON 内容：', e.message);
                //answerContent.value += dataContent;
              }
            //}
          }
        }
      } catch (e) {
        console.error('流式请求异常：', e);
      } finally {
        // 重置状态
        //isStreaming.value = false;
        //abortController = null;
      }
    }
    const regex = /```json\s*([\s\S]*?)\s*```/g
    let fullContent=ref('')
    // 提取所有 ```javascript ... ``` 代码块
    const extractedCharts = computed(() => {
      const charts = []
      let match
      while ((match = regex.exec(fullContent.value)) !== null) {
        try {
          const json = JSON.parse(match[1])
          if (json.option) {
            charts.push(json)
          }
        } catch (e) {
          console.warn('JSON解析失败:', e)
        }
      }
      return charts
    })

    let res_stream=null
    const sendMessage=async()=> {
      //判断是否登录
      let res= await getIsLogin();
      if(!res || res.code!=20000) return

      const content = inputText.value.trim();
      if (!content || isLoading.value) return;

      // 添加用户消息
      messages.value.push({
        role: 'user',
        content: content,
      });
      showMessages.value.push({
        role: 'user',
        content: content,
      });
      showMessages.value.push({
        role: 'assistant',
        content: '',
        reasoning_content:' '
      });
      inputText.value = '';
      isLoading.value = true;
      currentToolCall.value = null;
      await streamChat();
    }
    let i=0
    const streamChat=async()=> {
      fullContent.value= '';
      let reasoningContent='';
    
      let toolCallsBuffer = []; // 缓存工具调用片段
      i++;
      console.log('第'+i+'次调用:');

      res_stream = await client.chat.completions.create({
        //model: 'deepseek-v3.2',//阿里
        //model: 'deepseek-chat',//deepseek,
        //model:'Pro/deepseek-ai/DeepSeek-V3.2',//硅基流动
        model:modelList.value.find(t=>t.id==selModel.value).label,
        messages: JSON.parse(JSON.stringify(messages.value)),
        tools: enableTools.value ? tools : null,
        tool_choice: enableTools.value ? 'auto' : 'none',
        stream: true
      });
      try {
        // 遍历流式返回
        for await (const chunk of res_stream) {
          const delta = chunk.choices[0].delta;
          //console.log(chunk.choices[0])
          const finishReason = chunk.choices[0].finish_reason;
          // 判断1：检测到工具调用开始（关键）
          if (delta.tool_calls && delta.tool_calls.length > 0) { 
            // 收集工具调用片段（参数可能分多次返回）
            delta.tool_calls.forEach((toolCall) => {
              if (!toolCallsBuffer[toolCall.index]) {
                toolCallsBuffer[toolCall.index] = {
                  id: toolCall.id,
                  type: toolCall.type || 'function',
                  function: { name: '', arguments: '' }
                };
              }
              
              // 累加函数名和参数（流式是分片的）
              if (toolCall.function?.name) {
                toolCallsBuffer[toolCall.index].function.name += toolCall.function.name;
              }
              if (toolCall.function?.arguments) {
                toolCallsBuffer[toolCall.index].function.arguments += toolCall.function.arguments;
              }
            });
          }
          //普通内容输出
          if (delta.content) {
            fullContent.value += delta.content;
            //可能会有多个图表
            let new_fullContent=fullContent.value.replace(regex, `<div class="mychart_${i}" style="width:100%;height:260px;">图表生成中</div>`)
            const rawHtml = md.render(new_fullContent);
            showMessages.value[showMessages.value.length-1].content=DOMPurify.sanitize(rawHtml) || ''// XSS 防护;
            //console.log('消息内容:',fullContent.value)
          }
          //思考内容的输出
          if(delta.reasoning_content){
            reasoningContent+=delta.reasoning_content;
            showMessages.value[showMessages.value.length-1].reasoning_content+=delta.reasoning_content;
          }
          // 判断3：流结束，确定最终类型
          if (finishReason === 'tool_calls') {
            //console.log('工具调用收集完成:', toolCallsBuffer);
            // 执行工具调用逻辑
            await handleToolCalls(toolCallsBuffer,fullContent.value,reasoningContent);
            currentToolCall.value = null;

          } else if (finishReason === 'stop') {
            console.log('正常回答结束');
            // 保存到历史记录
            messages.value.push({ role: 'assistant', content: fullContent.value,reasoning_content:reasoningContent });
            //生成图表
            initCharts(`mychart_${i}`)
            isLoading.value = false;
          }
          //scrollToBottom();
        }
      } catch (error) {
        console.log(error)
        const rawHtml = md.render('服务器忙，请稍后再试！');
        showMessages.value[showMessages.value.length-1].content=DOMPurify.sanitize(rawHtml) || ''// XSS 防护;
      } finally {
        isLoading.value = false
      }
    }

    // 处理工具调用
    async function handleToolCalls(toolCalls,fullContent,reasoningContent) {
      console.log('工具',toolCalls)
      // 1. 添加助手消息（包含tool_calls）
      messages.value.push({
        role: 'assistant',
        content: fullContent, // 工具调用时content通常为空
        reasoning_content:reasoningContent,
        tool_calls: toolCalls.map(tc => ({
          id: tc.id,
          type: tc.type,
          function: {
            name: tc.function.name,
            arguments: tc.function.arguments // 已经是完整JSON字符串
          }
        }))
      });
      
      // 2. 执行工具（并行）
      const toolResults = await Promise.all(
        toolCalls.map(async (call) => {
          const result = await executeToolCall(call);
          
          return {
            role: 'tool',
            tool_call_id: call.id,
            content: JSON.stringify(result)
          };
        })
      );
      
      // 3. 添加工具结果
      messages.value.push(...toolResults);
      
      // 4. 递归/循环继续对话（流式）
      await streamChat();
    }
    
    // 执行工具调用（调用真实的 Web API）
    const executeToolCall = async (toolCall) => {
      const toolName = toolCall.function.name;
      const parameters = JSON.parse(toolCall.function.arguments);
      currentToolCall.value = { name: toolName, parameters };
      let toolDesc=''
      try {
        let result;
        switch (toolName) {
          case 'get_item_list':
            result = await getItemList({itemName:parameters.itemName,pageIndex:1,pageSize:20});
            break;
          case 'get_region_list':
            result = await getCodeRegionList({name:parameters.name,parent:parameters.parent});
            break;
            
          case 'get_regionItemData_List':
            result = await getMultiRegionItemDataList({regionCode:parameters.regionCode,itemId:parameters.itemId,dateType:1,date:parameters.date,endDate:parameters.endDate});
            toolDesc='宏观经济数据'
            break; 
          case 'get_industry_item_list':
            result = await getItemListOfEcoIndustry({itemName:parameters.itemName,industryId:parameters.industryId,pageIndex:1,pageSize:20});
            break; 
            
          case 'get_regionIndustryItemData_List':
            result = await getRegionIndustryDataList({regionCode:parameters.regionCode,itemId:parameters.itemId,objId:parameters.industryId,dateType:1,date:parameters.date,endDate:parameters.endDate,pageIndex:1,pageSize:500});
            toolDesc='行业数据'
            break; 
          case 'get_micro_item_List':
            result = await getItemObjList({class:parameters.class,pageIndex:1,pageSize:20});
            break; 
          case 'get_micro_product_List':
            result = await getProductList({name:parameters.name,pageIndex:1,pageSize:20});
            toolDesc='物价数据'
            break; 
          case 'get_micro_pos_List':
            result = await getPosList();
            break; 
          case 'get_houseData_List':
            result = await getHouseDataList({regionCode:parameters.regionCode,itemId:parameters.itemId,dateType:1,date:parameters.date,endDate:parameters.endDate,pageIndex:1,pageSize:100});
            toolDesc='房价数据'
            break; 
          case 'get_workData_List':
            result = await getWorkDataList({regionCode:parameters.regionCode,posId:parameters.posId,dateType:1,date:parameters.date,endDate:parameters.endDate,pageIndex:1,pageSize:200});
            toolDesc='招聘数据'
            break; 
          case 'get_productData_List':
            result = await getProductDataList({regionCode:parameters.regionCode,proId:parameters.proId,dateType:1,date:parameters.date,endDate:parameters.endDate,pageIndex:1,pageSize:200});
            break; 
          case 'web_search':
            result=await getWebSearch(parameters.query)
            toolDesc='联网搜索'
            break; 
          default:
            throw new Error(`未知的工具: ${toolName}`);
        }
        
        // 存储工具结果
        if(toolDesc){
          toolResults.value.push({id:toolCall.id,desc:toolDesc, data:result});
        }
        toolErrors.value.delete(toolCall.id);
        return result;
      } catch (error) {
        //console.error(`执行工具 ${toolName} 失败:`, error);
        toolErrors.value.set(toolCall.id, error.message);
        throw error;
      }
    };
    /***
     * 联网搜索
     */
    const getWebSearch=async(query)=>{
      let search_result=[];
      let res = await fetch('https://api.chinaecono.com/websearch/v3/openapi/workspaces/default/web-search/ops-web-search-001', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 如有认证需求，添加 token
          'Authorization': 'Bearer OS-ld356h5q5832srs4'
        },
        body: JSON.stringify({
          query: query,
          top_k:5
        }),
        cache: 'no-cache'
      });
      // 2. 校验响应是否成功
      if (!res.ok) {
        throw new Error(`请求失败：${res.status} ${res.statusText}`);
      }

      // 3. 获取 ReadableStream 并解析
      const reader = res.body?.getReader();
      if (!reader) {
        throw new Error('无法获取流式响应阅读器');
      }
      const decoder = new TextDecoder('utf-8'); // 用于解码 Uint8Array 为字符串
      // 4. 循环读取流式数据
      let  chunk=''
      let aa=true
      while (aa) {
        // 读取下一块数据
        const { done, value } = await reader.read();
        if (done) {
          // 数据读取完毕
          console.log('流式传输正常结束');
          break;
        }
        // 5. 解码并处理数据（拆分每条消息，处理 \n\n 分隔符）
        chunk+= decoder.decode(value, { stream: true });
        //console.log('搜索结果',chunk)
      }
      let result=JSON.parse(chunk);
      search_result=[...search_result,...result.result.search_result]
      return search_result;
    }
    /**
     * 大模型提取echart图表所属的option
     */
    const initCharts=async(id)=>{
      // 1. 根据class获取所有DOM对象
      const elements = document.getElementsByClassName(id);
      console.log('echart的个数', extractedCharts.value.length)
      // 2. 转换为数组（HTMLCollection是类数组，需要转换）
      const elementArray = Array.from(elements);
      
      // 3. 为每个DOM对象赋值唯一ID
      elementArray.forEach((element, index) => {
        // 赋值ID到DOM
        let domId=`${id}_${index}`;
        element.id =domId
        
        console.log(`✅ 已为第${index + 1}个元素分配ID: ${domId}`);
        
        // 4. 初始化ECharts实例
        //获取dom对象
        const dom = document.getElementById(domId)
        if (!dom) {
          console.error(`找不到dom元素: ${id}`)
          return
        }
        if(extractedCharts.value.length>0){
          try {
            const chart = echarts.init(dom)
            chart.setOption(extractedCharts.value[index].option)
          } catch (error) {
            dom.innerHTML = '<span>图表配置失败</span>'
          }
        }
        else{
          dom.innerHTML = '<span>图表配置失败</span>'
        }
      });
    }
    

    const handleShiftEnter = (e) => {
      e.preventDefault();
      const cursorPosition = e.target.selectionStart;
      const textBefore = inputText.value.substring(0, cursorPosition);
      const textAfter = inputText.value.substring(cursorPosition);
      inputText.value = textBefore + '\n' + textAfter;
      
      nextTick(() => {
        e.target.selectionStart = cursorPosition + 1;
        e.target.selectionEnd = cursorPosition + 1;
      });
    };
    const handleShiftEnter_start = (e) => {
      e.preventDefault();
      const cursorPosition = e.target.selectionStart;
      const textBefore = txtParams.value.substring(0, cursorPosition);
      const textAfter = txtParams.value.substring(cursorPosition);
      txtParams.value = textBefore + '\n' + textAfter;
      
      nextTick(() => {
        e.target.selectionStart = cursorPosition + 1;
        e.target.selectionEnd = cursorPosition + 1;
      });
    };

    const scrollToBottom = () => {
      nextTick(() => {
        if (messagesRef.value) {
          messagesRef.value.scrollTop = messagesRef.value.scrollHeight;
        }
      });
    };
    /**
     * 开启新的对话
     */
     const OpenNewdialogFun=()=>{
      console.log('开启新对话')
      router.push(`/agent?isShowHello=1&_t=${Date.now()}`)
    }
    /**
     * 创建新的对话
     */
    const AddNewdialogFun=()=>{
      if(!txtParams.value) return
      inputText.value=txtParams.value
      isShowHello.value=0
      sendMessage()
    }
    /**
     * 选择模型
     */
    const handleModelFun=(modelId)=>{
      console.log(modelId)
      selModel.value=modelId
    }
    /**
     * 取消对话
     */
    const cancelChat = () => {
      // OpenAI SDK 的 stream 可以调用 controller.abort()
      if (res_stream) {
        res_stream.controller.abort()
        res_stream = null
      }
      isLoading.value = false
    }
    //关闭登录对话框跳转到首页
    const loginCloseFun=()=>{
      router.push('/');
    }
    //搜索跳转
    const pushSearch= async (path,name)=>{
      console.log('路由判断页面是否可以访问',name);
      if(await getUserRightFun(name,0)){
        let href_='';
          const { href } = router.resolve({
            path: path,
          });
          href_=href;
        console.log(href_);
        window.open(href_, "_blank");
      }  
    }
    //退出
    const loginOut=()=>{
      //loginOut('xxx').then(response=>{// eslint-disable-line no-unused-vars
      localStorage.removeItem("accesstoken");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("refreshToken"); 
      if(route.path=='/' || route.path=='/index'){
          reload();
      }
      else{
          router.push('/')
      }
    }
    return {
      currentUser,
      modelList,
      selModel,
      handleModelFun,
      drawer,
      isShowHello,
      txtParams,
      OpenNewdialogFun,
      AddNewdialogFun,
      dialogList,
      isShowThinking,
      inputText,
      messages,
      showMessages,
      messagesRef,
      extractedCharts,
      isLoading,
      enableTools,
      currentToolCall,
      sendMessage,
      sendMessage2,
      toolResults,
      toolErrors,
      handleShiftEnter,
      handleShiftEnter_start,
      scrollToBottom,

      loginCloseFun,
      pushSearch,
      loginOut,
    }
  }
}
</script>

<style scoped>
.direct-api-chat {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 1240px;
  background-color: #fff;
}
.chat-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    z-index: 11;
    background: white;
    gap: 20px;
    padding: 0 20px;
    border-bottom: 1px solid #f5f5f5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.chat-aside{
    display: flex;
    width: 261px;
}
.fold-aside-new {
    background: #fff;
    border-radius: 22px;
    justify-content: center;
    align-items: center;
    gap: 0;
    height: 36px;
    padding: 0;
    display: flex;
    margin-top: 10px;
    margin-left: 10px;
    box-sizing: border-box;
    border: .5px solid #f5f5f5;
    box-shadow: 0 5px 16px -4px #00000012;
}
.fold-aside-expand {
    justify-content: center;
    align-items: center;
    height: 20px;
    padding: 7px 11px 8px 15px;
    display: flex;
    cursor: pointer;
}
.fold-aside-divider {
    background: rgba(78, 110, 242, .1);
    flex-shrink: 0;
    width: .5px;
    height: 9px;
}
.fold-aside-new-dialog {
    justify-content: center;
    align-items: center;
    padding: 8px 14px 7px 12px;
    transition: background-color .2s;
    display: flex;
    cursor: pointer;
}
.dc04ec1d {
    /* will-change: transform, max-width;
    transition: transform 0.3s cubic-bezier(.4,0,.2,1), max-width 0.3s cubic-bezier(.4,0,.2,1); 
    transform: translate(0);*/
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-right: 1px solid #f5f5f5;
}
.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px 10px 9px 16px;
    height: 32px;
    box-sizing: content-box;
    cursor: pointer;
}
.sidebar-nav-title {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    padding: 10px 8px;
    gap: 3px;
}
.chat-info-item {
    padding: 10px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
    -webkit-text-decoration: none;
    text-decoration: none;
    margin-left: 28px;
    border-radius: 8px;
    color: rgba(0, 0, 0, .6);
}
.router-link-active {
    background: rgba(0, 0, 0, .05);
    color: rgba(0, 0, 0, .9);
}
.chat-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.chat-container-pc {
    height:calc(100% - 50px);
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    justify-content: space-between;
    display: flex;
    position: relative;
}
.right-bar-wrapper {
    border-left: 1px solid #f5f5f5;
    overflow-y: auto;
    height: 100%;
}
.wrapper-head {
    color: #9195a3;
    align-items: center;
    padding: 21px 12px 12px;
    font-weight: 500;
    display: flex;
    background-color: rgba(0, 0, 0, .05);
    border-bottom: 1px solid #f5f5f5;
}
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex:1;
  max-width: 848px;
  background: white;
  overflow: hidden;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  /* background: #fafafa; */
}

.message {
  margin-bottom: 20px;
  animation: fadeIn 0.3s ease-in;
}

.message.user {
  display: flex;
  justify-content: flex-end;
}

.message.assistant {
  display: flex;
  justify-content: flex-start;
}

.message-content {
  display: flex;
  gap: 16px;
  width: 100%;
}

.message.user .message-content {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.message.user .message-avatar {
  background: #1890ff;
  color: white;
}

.message-text {
  padding: 16px 20px;
  border-radius: 16px;
  /* background: white;
  border: 1px solid #e8e8e8; */
  max-width: 100%;
  word-wrap: break-word;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
}

.message.user .message-text {
  background: #1890ff;
  color: white;
  border: none;
}

.thinking-content {
  margin-bottom: 12px;
  padding: 12px;
  background: #fff7e6;
  border-radius: 8px;
  border-left: 4px solid #fa8c16;
}

.thinking-label {
  font-weight: bold;
  color: #fa8c16;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.thinking-text {
  color: #666;
  font-style: italic;
  line-height: 1.5;
}

.loading {
  padding: 20px;
  text-align: center;
}

.loading-content {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-dots {
  display: inline-flex;
  gap: 6px;
}

.loading-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1890ff;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }

.tool-calling {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
.input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.input-header h3 {
  margin: 0;
  color: #333;
}

.input-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.control-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.docs-btn {
  padding: 6px 12px;
  background: white;
  border: 1px solid #1890ff;
  color: #1890ff;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.docs-btn:hover {
  background: #1890ff;
  color: white;
}

.input-wrapper {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  flex-direction: column;
  padding: 10px;
  box-shadow: 0 5px 16px -4px #00000012;
}

textarea {
  flex: 1;
  border: none;
  resize: none;
  font-family: inherit;
  font-size: 15px;
  transition: all 0.2s;
}

textarea:focus {
  outline: none;
  
  border-color: transparent;
}

textarea:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.send-button {
  background: #002FA7;
  padding: 8px 9px;
  color: white;
  border: none;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  align-self: flex-end;
}

.send-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.quick-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.actions-label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

.actions-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-button {
  padding: 6px 12px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.action-button:hover {
  border-color: #1890ff;
  color: #1890ff;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1.0); }
}

/* 滚动条样式 */
.messages::-webkit-scrollbar,
.docs-content::-webkit-scrollbar {
  width: 6px;
}

.messages::-webkit-scrollbar-track,
.docs-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.messages::-webkit-scrollbar-thumb,
.docs-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.messages::-webkit-scrollbar-thumb:hover,
.docs-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>